"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraDataControl = void 0;
var react_1 = __importStar(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
// import { ButtonControl } from "../button/button";
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
// import { TextInputControl } from "../textinput/textinput";
var ExtraDataControl = function (props) {
    var title = props.title, extra_data = props.extra_data, onChange = props.onChange, isLoading = props.isLoading;
    var _a = (0, react_1.useState)([]), selectedExtraData = _a[0], setSelectedExtraData = _a[1]; // { key: "", value: "" }
    var _b = (0, react_1.useState)([]), loading = _b[0], setLoading = _b[1];
    (0, react_1.useEffect)(function () {
        //     console.log("extra_data", extra_data);
        setSelectedExtraData(extra_data);
    }, [extra_data]);
    (0, react_1.useEffect)(function () {
        setLoading(isLoading);
    }, [isLoading]);
    return (react_1.default.createElement("div", { className: "flex flex-col space-y-2 p-4 bg-white rounded-xl w-full" },
        title && react_1.default.createElement("div", { className: "text-lg" }, title),
        loading ? ("Loading...") : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "flex flex-wrap w-full" }, selectedExtraData.map(function (extraData, index) { return (react_1.default.createElement("div", { key: index, className: "flex items-start p-2 relative w-1/3 min-w-[300px]" // 3 per row (33.33% width)
             },
                react_1.default.createElement("div", { className: "flex gap-2 w-full" },
                    react_1.default.createElement("div", { className: "flex flex-col flex-1" },
                        react_1.default.createElement("label", { className: "text-sm font-medium" }, "Key"),
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { value: extraData.key, onChange: function (v) {
                                var updated = __spreadArray([], selectedExtraData, true);
                                updated[index].key = v;
                                setSelectedExtraData(updated);
                                onChange(updated);
                            } })),
                    react_1.default.createElement("div", { className: "flex flex-col flex-1" },
                        react_1.default.createElement("label", { className: "text-sm font-medium" }, "Value"),
                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { value: extraData.value, onChange: function (v) {
                                var updated = __spreadArray([], selectedExtraData, true);
                                updated[index].value = v;
                                setSelectedExtraData(updated);
                                onChange(updated);
                            } }))),
                react_1.default.createElement("button", { className: "absolute top-0 right-0 \n                   bg-red-500 hover:bg-red-600 transition-all\n                   w-5 h-5 flex justify-center items-center \n                   rounded-full cursor-pointer text-white", onClick: function () {
                        var updated = selectedExtraData.filter(function (_, i) { return i !== index; });
                        setSelectedExtraData(updated);
                        onChange(updated);
                    } },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTimes, className: "text-xs" })))); })))),
        react_1.default.createElement("div", { className: "pt-2 w-80" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: selectedExtraData.length == 0 ? "Add data" : "Add more data", onClick: function () {
                    var _a, _b;
                    var lastIndex = (_b = (_a = selectedExtraData[selectedExtraData.length - 1]) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : 0;
                    selectedExtraData.push({ key: "", value: null });
                    setSelectedExtraData(__spreadArray([], selectedExtraData, true));
                    onChange(selectedExtraData);
                } }))));
};
exports.ExtraDataControl = ExtraDataControl;
